/**
 * Reviews Carousel Section
 * Vanilla JavaScript carousel with auto-advance
 */
(function() {
  'use strict';

  const carousels = document.querySelectorAll('.reviews-carousel-section');
  
  carousels.forEach(initCarousel);

  function initCarousel(carousel) {
    const slides = carousel.querySelectorAll('.reviews-carousel__slide');
    const dots = carousel.querySelectorAll('.reviews-carousel__dot');
    const prevButton = carousel.querySelector('.reviews-carousel__nav-button--prev');
    const nextButton = carousel.querySelector('.reviews-carousel__nav-button--next');
    
    if (slides.length <= 1) return;

    let currentIndex = 0;
    let autoAdvanceTimer = null;
    
    const autoAdvance = carousel.dataset.autoAdvance === 'true';
    const autoAdvanceSpeed = parseInt(carousel.dataset.autoAdvanceSpeed, 10) || 5000;

    // Event listeners
    if (prevButton) {
      prevButton.addEventListener('click', () => {
        goToSlide(currentIndex - 1);
        resetAutoAdvance();
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        goToSlide(currentIndex + 1);
        resetAutoAdvance();
      });
    }

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        goToSlide(index);
        resetAutoAdvance();
      });
    });

    // Pause auto-advance on hover
    carousel.addEventListener('mouseenter', () => {
      stopAutoAdvance();
    });

    carousel.addEventListener('mouseleave', () => {
      if (autoAdvance) {
        startAutoAdvance();
      }
    });

    // Keyboard navigation
    carousel.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        goToSlide(currentIndex - 1);
        resetAutoAdvance();
      } else if (e.key === 'ArrowRight') {
        goToSlide(currentIndex + 1);
        resetAutoAdvance();
      }
    });

    // Touch/swipe support
    let touchStartX = 0;
    let touchEndX = 0;

    carousel.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    carousel.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    }, { passive: true });

    function handleSwipe() {
      const swipeThreshold = 50;
      const diff = touchStartX - touchEndX;

      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          // Swipe left - next slide
          goToSlide(currentIndex + 1);
        } else {
          // Swipe right - prev slide
          goToSlide(currentIndex - 1);
        }
        resetAutoAdvance();
      }
    }

    function goToSlide(index) {
      // Handle wrapping
      if (index < 0) {
        index = slides.length - 1;
      } else if (index >= slides.length) {
        index = 0;
      }

      // Update slides
      slides[currentIndex].classList.remove('reviews-carousel__slide--active');
      slides[index].classList.add('reviews-carousel__slide--active');

      // Update dots
      if (dots.length > 0) {
        dots[currentIndex].classList.remove('reviews-carousel__dot--active');
        dots[index].classList.add('reviews-carousel__dot--active');
      }

      currentIndex = index;
    }

    function startAutoAdvance() {
      if (autoAdvanceTimer) return;
      
      autoAdvanceTimer = setInterval(() => {
        goToSlide(currentIndex + 1);
      }, autoAdvanceSpeed);
    }

    function stopAutoAdvance() {
      if (autoAdvanceTimer) {
        clearInterval(autoAdvanceTimer);
        autoAdvanceTimer = null;
      }
    }

    function resetAutoAdvance() {
      stopAutoAdvance();
      if (autoAdvance) {
        startAutoAdvance();
      }
    }

    // Start auto-advance if enabled
    if (autoAdvance) {
      startAutoAdvance();
    }

    // Pause when tab is not visible
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stopAutoAdvance();
      } else if (autoAdvance) {
        startAutoAdvance();
      }
    });
  }
})();
